export default __webpack_public_path__ + "static/media/email-verifier-success.233aa193.svg";